import React from 'react';

import { Typography } from '@material-ui/core';
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';

import processing_activities_messages from 'messages/processing_activities_messages';

import type { ProcessingActivityChangelogEntry } from '../processingActivityDetail.types';
import useStyles from '../ProcessingActivityDetailPage.styles';

type Props = {
  entries: ProcessingActivityChangelogEntry[];
};

const formatDate = (value?: string) => (value ? format(new Date(value), 'yyyy-MM-dd') : '—');

const ProcessingActivityChangelogSection: React.FC<Props> = ({ entries }) => {
  const { t } = useTranslation();
  const styles = useStyles();

  return (
    <div className={styles.panel}>
      <Typography className={styles.panelTitle} component='h2' variant='h6'>
        {t(processing_activities_messages.detail.sections.changelog)}
      </Typography>

      {entries.length === 0 ? (
        <Typography color='textSecondary' variant='body2'>
          {t(processing_activities_messages.detail.empty_state.no_changelog)}
        </Typography>
      ) : (
        entries.map(entry => (
          <div key={entry.versionNumber} className={styles.timelineItem}>
            <div className={styles.timelineTitle}>
              {t(processing_activities_messages.detail.changelog.version_label, { number: entry.versionNumber })}
            </div>
            <div className={styles.timelineMeta}>
              {t(processing_activities_messages.detail.changelog.published_meta, {
                date: formatDate(entry.publishedAt),
                name: entry.publishedByDisplayName || t(processing_activities_messages.review_placeholder),
              })}
            </div>
            <div className={styles.readValue}>{entry.changeComment || t(processing_activities_messages.review_placeholder)}</div>
          </div>
        ))
      )}
    </div>
  );
};

export default ProcessingActivityChangelogSection;
